import { useTranslation } from "react-i18next";
import { SsqProperty } from "src/api/sure-api/actions/useGetOneAction";

type ActionGroupPropertyProps = {
    property: SsqProperty;
};
export const ActionGroupProperty = (props: ActionGroupPropertyProps) => {
    const { t } = useTranslation();
    return <>{t("action_plan.action.group_property", "Group property")}</>;

    // const { t } = useTranslation();
    // const theme = useTheme();
    // const { startProperty, endProperty } = props;

    // const startTitle = t("action_plan.value_in_year", { year: startProperty.campaign?.label });
    // const targetTitle = `${t("goal")} ${endProperty.campaign?.label}`;

    // return (
    //     <Stack gap={theme.spacing(2)}>
    //         <PropertyHeader startTitle={startTitle} targetTitle={targetTitle} />
    //         {endProperty.content?.flatMap((childProperty, idx) => {
    //             const foundStarting = startProperty.content.find(
    //                 (elem) => elem.property.id === childProperty.property.id,
    //             );
    //             const foundTarget = endProperty.content.find((elem) => elem.property.id === childProperty.property.id);
    //             return [
    //                 <Stack key={`${idx}-group`} flexDirection={"row"}>
    //                     <CenteredStack borderRight={`1px solid ${theme.custom.grey[1400]}`} gap={theme.spacing(0.5)}>
    //                         <Fragment>
    //                             <ValueSwitch
    //                                 comparisonProperty={undefined}
    //                                 property={foundStarting}
    //                                 title={foundStarting?.property.title}
    //                                 variant="readonly"
    //                             />
    //                         </Fragment>
    //                     </CenteredStack>
    //                     <CenteredStack>
    //                         <ValueSwitch
    //                             comparisonProperty={foundStarting}
    //                             property={foundTarget}
    //                             title={foundTarget?.property.title}
    //                             shouldShowSubscore={endProperty.isSubpropertyOverriden}
    //                         />
    //                     </CenteredStack>
    //                 </Stack>,
    //             ];
    //         })}
    //     </Stack>
    // );
};
